import { createContext, Fragment, useState, useEffect } from 'react'

import { getCookie, removeCookies } from 'cookies-next'
import ReactSlidingPane from 'react-sliding-pane'

import ContactForm from './ContactForm'

interface ContextProps {
  open: boolean
  setOpen: Function
}

export const Context = createContext<ContextProps>({
  open: false,
  setOpen: () => {},
})
Context.displayName = 'ContactContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
  collectionId: string
}

const ContactContext = ({ children, collectionId }: Props) => {
  const [open, setOpen] = useState<boolean>(false)

  const value = {
    open,
    setOpen,
  }

  return (
    <Fragment>
      <Provider value={value}>{children}</Provider>
      {open && (
        <ReactSlidingPane
          from="bottom"
          hideHeader
          isOpen={open}
          onRequestClose={() => setOpen(false)}
          overlayClassName="z-30 w-screen"
          shouldCloseOnEsc
          width="100%"
        >
          <ContactForm collectionId={collectionId} />
        </ReactSlidingPane>
      )}
    </Fragment>
  )
}

export default ContactContext
